var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaryConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.008,
    height: 740.66,
    viewBox: "0 0 800.008 740.66",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560 -170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M570.36,395.948l-66.507-34.583s-22.334-24.6-36.36-35.7-18.344-2.948-18.344-2.948l-5.9,9.827L457.5,352.357l38.489,32.593,68.773,26.937a10.906,10.906,0,1,0,5.6-15.939Z",
    transform: "translate(256.438 189.043)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.465,365.451l-3.937-24.089-11.118-2.779s-8.824-2.718-10.886,15.056-.463,50.957-.463,50.957l-22.573,71.481a10.93,10.93,0,1,0,15.227,7.314L396.3,415.713Z",
    transform: "translate(253.344 189.631)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.545,455.631h14.548l6.922-56.115H246.542Z",
    transform: "translate(499.225 437.5)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.716,455.631h14.549l6.921-56.115H92.714Z",
    transform: "translate(494.372 437.5)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.732,309.288H379.491a5.067,5.067,0,0,1-5.062-5.062V276.1a37.682,37.682,0,1,1,75.364,0v28.121A5.067,5.067,0,0,1,444.732,309.288Z",
    transform: "translate(254.268 186.475)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.391,10.373S47.03,38.7,49.168,47.248a23.408,23.408,0,0,1-1.6,15.5L22.981,61.677,0,39.766S34.738,15.717,32.6,3.96,60.391,10.373,60.391,10.373Z",
    transform: "translate(634.085 491.094) rotate(-19)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.427,318.073l-24.131,20.6,19.8,62.669,4.468,13.994s-27.285,25.156-44.167,95.431-44.5,163.652-44.5,163.652L376.2,691.105l47.427-158.967,55.785,124.715,6.441,36.888L535.494,679.1l-11.71-92.512L465.232,426.452,471.314,384s9.133-21.188-6.733-43.621L459.6,319.3l-17.829-4.391Z",
    transform: "translate(252.484 188.889)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.627,
    cy: 27.627,
    r: 27.627,
    transform: "translate(636.627 478.471) rotate(-61.337)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.126,278.607H418.233l-.409-5.727-2.045,5.727h-6.143l-.811-11.352-4.054,11.352H392.885v-.562a29.842,29.842,0,0,1,29.808-29.808h5.624a29.842,29.842,0,0,1,29.808,29.808Z",
    transform: "translate(254.85 186.785)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.062,313.846a5.167,5.167,0,0,1-.9-.079l-29.212-5.154V260.335h32.156l-.8.928c-11.077,12.918-2.732,33.865,3.228,45.2a4.987,4.987,0,0,1-.4,5.295,5.041,5.041,0,0,1-4.085,2.087Z",
    transform: "translate(254.694 187.166)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.537,562.877,405.526,653.391a25.342,25.342,0,0,1-32.3-15.427L329.244,513.575a25.342,25.342,0,0,1,15.428-32.3l256.011-90.515a25.342,25.342,0,0,1,32.3,15.428l43.979,124.389a25.342,25.342,0,0,1-15.427,32.3Z",
    transform: "translate(252.796 191.234)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.549,526.253l.233.658a24.174,24.174,0,0,1-14.738,30.847L403.752,648.726a24.173,24.173,0,0,1-30.845-14.731l-.233-.658Z",
    transform: "translate(254.212 195.555)",
    fill: "#f2f2f2",
    opacity: 0.096
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.078,506.905c-16.97,11.166-38.719,2.763-46.325-9.478l1.213-.689C358.413,487.734,379.867,492.751,389.078,506.905Z",
    transform: "translate(253.269 194.482)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.661,539.09c-4.154,1.469-7.893,1.4-11.117-.2-7.286-3.62-10.7-14.353-13.451-22.978-.8-2.509-1.554-4.879-2.323-6.816l-.011-.03a15.446,15.446,0,0,1,9.36-19.611l34.435-12.175c4.148-1.467,7.884-1.4,11.1.2,7.284,3.615,10.705,14.345,13.455,22.966.8,2.514,1.559,4.889,2.33,6.829a15.455,15.455,0,0,1-9.356,19.644ZM569.2,508.545c.786,1.984,1.547,4.373,2.353,6.9,2.659,8.349,5.969,18.739,12.672,22.07,2.877,1.429,6.123,1.471,9.923.128l34.425-12.171a13.911,13.911,0,0,0,8.433-17.661c-.78-1.96-1.545-4.359-2.355-6.9-2.661-8.345-5.974-18.732-12.675-22.058-2.874-1.427-6.117-1.468-9.911-.127L577.632,490.9a13.908,13.908,0,0,0-8.431,17.644Z",
    transform: "translate(260.34 193.977)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.991,510.952a34.226,34.226,0,0,1-18.814,1.034c-9.12-2-17.4-7.447-21.6-14.209l-.421-.678,1.893-1.076c14.664-9.134,36.654-4.182,46.145,10.4l.416.639-.637.42A32.2,32.2,0,0,1,381.991,510.952Zm-38.676-13.315c4.113,6.112,11.767,11,20.191,12.85a31.978,31.978,0,0,0,23.972-3.869c-9.284-13.43-29.854-17.885-43.63-9.286Z",
    transform: "translate(253.218 194.457)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.024,598.247a12.732,12.732,0,0,1-12.947-2.15,15.926,15.926,0,0,1-5.21-14.721,12.777,12.777,0,0,1,8.973-9.906l45.882-16.222a12.8,12.8,0,0,1,13.2,2.076,15.926,15.926,0,0,1,5.2,14.721c-.906,4.735-4.1,8.223-8.975,9.892l-45.883,16.222Zm-8.9-25.252a11.276,11.276,0,0,0-7.752,8.669,14.347,14.347,0,0,0,4.694,13.262,11.286,11.286,0,0,0,11.673,1.792l45.9-16.23a11.3,11.3,0,0,0,7.969-8.73,14.346,14.346,0,0,0-4.688-13.262,11.335,11.335,0,0,0-11.683-1.8l-45.908,16.231-.211.073Z",
    transform: "translate(254.179 196.439)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.708,501.916l-14.464,5.114a3.835,3.835,0,0,1-2.557-7.232l14.464-5.114a3.835,3.835,0,0,1,2.557,7.232Z",
    transform: "translate(260.599 194.553)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.674,513.134l-14.464,5.114a3.835,3.835,0,0,1-2.557-7.232l14.464-5.114a3.835,3.835,0,1,1,2.557,7.232Z",
    transform: "translate(260.725 194.906)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.64,524.351l-14.464,5.114a3.835,3.835,0,0,1-2.557-7.232l14.464-5.114a3.835,3.835,0,1,1,2.557,7.232Z",
    transform: "translate(260.85 195.26)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.246,493.241l-14.464,5.114a3.835,3.835,0,0,1-2.557-7.232l14.464-5.114a3.835,3.835,0,0,1,2.557,7.232Z",
    transform: "translate(261.373 194.279)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.212,504.458l-14.464,5.114a3.835,3.835,0,1,1-2.557-7.232l14.464-5.114a3.835,3.835,0,1,1,2.557,7.232Z",
    transform: "translate(261.498 194.633)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.178,515.675l-14.464,5.114a3.835,3.835,0,0,1-2.557-7.232l14.464-5.114a3.835,3.835,0,1,1,2.557,7.232Z",
    transform: "translate(261.623 194.986)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 321.246,
    height: 1.534,
    transform: "matrix(0.943, -0.333, 0.333, 0.943, 592.484, 731.58)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.537,562.877,405.526,653.391a25.342,25.342,0,0,1-32.3-15.427L329.244,513.575a25.342,25.342,0,0,1,15.428-32.3l256.011-90.515a25.342,25.342,0,0,1,32.3,15.428l43.979,124.389a25.342,25.342,0,0,1-15.427,32.3ZM345.183,482.718a23.806,23.806,0,0,0-14.493,30.346l43.979,124.389a23.806,23.806,0,0,0,30.345,14.493L661.026,561.43a23.806,23.806,0,0,0,14.493-30.345L631.539,406.7A23.806,23.806,0,0,0,601.194,392.2Z",
    transform: "translate(252.796 191.234)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.935,805.942a22.884,22.884,0,0,1-15.521,5.654c-10.511-.154-30.15-.468-34.71-.662-6.1-.275-4.078-5.6-3.88-9.264v-.363c.071-3.675.79-11.639,2.007-12.883s5.382,5.541,5.382,5.541,8.132,2.423,10.369-4.846,6.781-7.972,6.781-7.972c2.063-.913,2.165,4.571,2.165,4.571l17.213,9.07,10.1,1.616c.324.153.616.307.893.46C270.3,799.48,268.278,802.986,264.935,805.942Z",
    transform: "translate(529.934 96.809)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.935,805.942a22.884,22.884,0,0,1-15.521,5.654c-10.511-.154-30.15-.468-34.71-.662-6.1-.275-4.078-5.6-3.88-9.264v-.363c.071-3.675.79-11.639,2.007-12.883s5.382,5.541,5.382,5.541,8.132,2.423,10.369-4.846,6.781-7.972,6.781-7.972c2.063-.913,2.165,4.571,2.165,4.571l17.213,9.07,10.1,1.616c.324.153.616.307.893.46C270.3,799.48,268.278,802.986,264.935,805.942Z",
    transform: "translate(372.891 96.809)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.679,255.2h-4.073V143.715a64.523,64.523,0,0,0-64.523-64.522h-236.2a64.522,64.522,0,0,0-64.523,64.522V755.331a64.523,64.523,0,0,0,64.523,64.522h236.2a64.523,64.523,0,0,0,64.523-64.523V334.558h4.071Z",
    transform: "translate(691.947 90.807)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.378,95.686H538.547a22.893,22.893,0,0,1-21.2,31.539H382.031a22.893,22.893,0,0,1-21.2-31.539h-28.8a48.187,48.187,0,0,0-48.187,48.187V754.59a48.187,48.187,0,0,0,48.187,48.187H569.368a48.187,48.187,0,0,0,48.187-48.186V143.873a48.187,48.187,0,0,0-48.176-48.187Z",
    transform: "translate(691.234 91.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,669.03c0,.724,1.4,1.3,3.148,1.3H796.86c1.746,0,3.148-.581,3.148-1.3s-1.4-1.305-3.148-1.305H3.148C1.4,667.725,0,668.306,0,669.03Z",
    transform: "translate(560 240.273)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1004.795 393.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.44,473.526H235.29a9.111,9.111,0,0,1-9.1-9.1V436.648a9.111,9.111,0,0,1,9.1-9.1H493.44a9.111,9.111,0,0,1,9.1,9.1v27.779a9.111,9.111,0,0,1-9.1,9.1ZM235.29,428.5a8.151,8.151,0,0,0-8.142,8.142v27.779a8.151,8.151,0,0,0,8.142,8.142H493.44a8.151,8.151,0,0,0,8.142-8.142V436.648a8.151,8.151,0,0,0-8.142-8.144Z",
    transform: "translate(-226.19 -427.548)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.616,472.332a15.839,15.839,0,1,1,15.839-15.839,15.839,15.839,0,0,1-15.839,15.839Z",
    transform: "translate(-249.633 -433.504)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.174,487.007H360.108a3.832,3.832,0,1,1,0-7.663H529.174a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.308 -451.086)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.089,457.158H360.1a3.832,3.832,0,1,1,0-7.663H474.089a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.305 -437.521)",
    fill: "#f59e0b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1004.795 464.189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.44,473.526H235.29a9.111,9.111,0,0,1-9.1-9.1V436.648a9.111,9.111,0,0,1,9.1-9.1H493.44a9.111,9.111,0,0,1,9.1,9.1v27.779a9.111,9.111,0,0,1-9.1,9.1ZM235.29,428.5a8.151,8.151,0,0,0-8.142,8.142v27.779a8.151,8.151,0,0,0,8.142,8.142H493.44a8.151,8.151,0,0,0,8.142-8.142V436.648a8.151,8.151,0,0,0-8.142-8.144Z",
    transform: "translate(-226.19 -427.548)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.616,472.332a15.839,15.839,0,1,1,15.839-15.839,15.839,15.839,0,0,1-15.839,15.839Z",
    transform: "translate(-249.633 -433.504)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.174,487.007H360.108a3.832,3.832,0,1,1,0-7.663H529.174a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.308 -451.086)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.089,457.158H360.1a3.832,3.832,0,1,1,0-7.663H474.089a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.305 -437.521)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1004.795 534.336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.44,473.526H235.29a9.111,9.111,0,0,1-9.1-9.1V436.648a9.111,9.111,0,0,1,9.1-9.1H493.44a9.111,9.111,0,0,1,9.1,9.1v27.779a9.111,9.111,0,0,1-9.1,9.1ZM235.29,428.5a8.151,8.151,0,0,0-8.142,8.142v27.779a8.151,8.151,0,0,0,8.142,8.142H493.44a8.151,8.151,0,0,0,8.142-8.142V436.648a8.151,8.151,0,0,0-8.142-8.144Z",
    transform: "translate(-226.19 -427.548)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.616,472.332a15.839,15.839,0,1,1,15.839-15.839,15.839,15.839,0,0,1-15.839,15.839Z",
    transform: "translate(-249.633 -433.504)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.174,487.007H360.108a3.832,3.832,0,1,1,0-7.663H529.174a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.308 -451.086)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.089,457.158H360.1a3.832,3.832,0,1,1,0-7.663H474.089a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.305 -437.521)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1004.795 605.512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.44,473.526H235.29a9.111,9.111,0,0,1-9.1-9.1V436.648a9.111,9.111,0,0,1,9.1-9.1H493.44a9.111,9.111,0,0,1,9.1,9.1v27.779a9.111,9.111,0,0,1-9.1,9.1ZM235.29,428.5a8.151,8.151,0,0,0-8.142,8.142v27.779a8.151,8.151,0,0,0,8.142,8.142H493.44a8.151,8.151,0,0,0,8.142-8.142V436.648a8.151,8.151,0,0,0-8.142-8.144Z",
    transform: "translate(-226.19 -427.548)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.616,472.332a15.839,15.839,0,1,1,15.839-15.839,15.839,15.839,0,0,1-15.839,15.839Z",
    transform: "translate(-249.633 -433.504)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.174,487.007H360.108a3.832,3.832,0,1,1,0-7.663H529.174a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.308 -451.086)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.089,457.158H360.1a3.832,3.832,0,1,1,0-7.663H474.089a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.305 -437.521)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1003.764 675.658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.44,473.526H235.29a9.111,9.111,0,0,1-9.1-9.1V436.648a9.111,9.111,0,0,1,9.1-9.1H493.44a9.111,9.111,0,0,1,9.1,9.1v27.779a9.111,9.111,0,0,1-9.1,9.1ZM235.29,428.5a8.151,8.151,0,0,0-8.142,8.142v27.779a8.151,8.151,0,0,0,8.142,8.142H493.44a8.151,8.151,0,0,0,8.142-8.142V436.648a8.151,8.151,0,0,0-8.142-8.144Z",
    transform: "translate(-226.19 -427.548)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.616,472.332a15.839,15.839,0,1,1,15.839-15.839,15.839,15.839,0,0,1-15.839,15.839Z",
    transform: "translate(-249.633 -433.504)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.174,487.007H360.108a3.832,3.832,0,1,1,0-7.663H529.174a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.308 -451.086)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.089,457.158H360.1a3.832,3.832,0,1,1,0-7.663H474.089a3.832,3.832,0,1,1,0,7.663Z",
    transform: "translate(-285.305 -437.521)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 61.893,
    cy: 61.893,
    r: 61.893,
    transform: "translate(1081.075 242.59)",
    fill: "#f59e0b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.774,257.615H323.768a.557.557,0,0,1,0-1.115H488.774a.557.557,0,0,1,0,1.115Z",
    transform: "translate(735.666 519.311)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.774,291.615H323.768a.557.557,0,0,1,0-1.115H488.774a.557.557,0,0,1,0,1.115Z",
    transform: "translate(735.666 504.266)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.774,325.615H323.768a.557.557,0,0,1,0-1.115H488.774a.557.557,0,0,1,0,1.115Z",
    transform: "translate(735.666 489.221)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.774,359.615H323.768a.557.557,0,0,1,0-1.115H488.774a.557.557,0,0,1,0,1.115Z",
    transform: "translate(735.666 474.172)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.164,363.079H414a2.79,2.79,0,0,1-2.787-2.787v-34A2.79,2.79,0,0,1,414,323.5h16.166a2.79,2.79,0,0,1,2.787,2.787v34A2.79,2.79,0,0,1,430.164,363.079Z",
    transform: "translate(686.778 489.66)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.164,348.033H480a2.79,2.79,0,0,1-2.787-2.787V292.287A2.79,2.79,0,0,1,480,289.5h16.166a2.79,2.79,0,0,1,2.787,2.787v52.958a2.79,2.79,0,0,1-2.787,2.787Z",
    transform: "translate(657.569 504.709)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.164,333.429H548a2.791,2.791,0,0,1-2.787-2.787V259.287A2.791,2.791,0,0,1,548,256.5h16.166a2.791,2.791,0,0,1,2.787,2.787v71.354a2.791,2.791,0,0,1-2.787,2.787Z",
    transform: "translate(627.477 519.311)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.774,393.615H323.768a.557.557,0,0,1,0-1.115H488.774a.557.557,0,0,1,0,1.115Z",
    transform: "translate(735.666 459.127)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.512-33.356v-6.421q-8.088-.486-12.878-4.6T5.566-55.709H14.7a7.549,7.549,0,0,0,2.742,5.588,11.6,11.6,0,0,0,6.074,2.4V-63.068L20.735-63.8A23.028,23.028,0,0,1,10.617-68.83,11.51,11.51,0,0,1,6.99-77.681a13.385,13.385,0,0,1,2.135-7.5A15.552,15.552,0,0,1,14.99-90.42a22.083,22.083,0,0,1,8.521-2.4v-6.56h4.165v6.526a21.336,21.336,0,0,1,8.764,2.291,15.521,15.521,0,0,1,5.849,5.207,13.657,13.657,0,0,1,2.221,7.289h-8.99a6.861,6.861,0,0,0-2.4-4.686,10.123,10.123,0,0,0-5.45-2.187v14.474l2.326.59a34.578,34.578,0,0,1,7.307,2.69A15.871,15.871,0,0,1,43-62.478a12.128,12.128,0,0,1,2.2,7.463,13.656,13.656,0,0,1-4.6,10.587q-4.6,4.165-12.93,4.651v6.421Zm4.165-14.4a10.878,10.878,0,0,0,5.988-2.43,6.233,6.233,0,0,0,2.274-4.894,4.923,4.923,0,0,0-2.256-4.356,20.324,20.324,0,0,0-6-2.516ZM23.512-71.537V-84.9a9.327,9.327,0,0,0-5.259,2.291,5.822,5.822,0,0,0-1.892,4.373,4.957,4.957,0,0,0,2.2,4.356A17.887,17.887,0,0,0,23.512-71.537Z",
    transform: "translate(1117.584 370.848)",
    fill: "#f2f2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryConfig);
export default __webpack_public_path__ + "static/media/salary-config.a0b924ba9d0d8ea9d43c07d501734cb4.svg";
export { ForwardRef as ReactComponent };